
    <div class="flex-row">
        <button 
            (click)="downloadTemplate()" 
            class="icon-button flex-row" 
            tabindex="0"
            title="Download template"
        >
            <div class="icon-button__cover"></div>
            <div class="action">
                <clr-icon shape="download" size="24" class="ng-star-inserted"></clr-icon>
            </div>
        </button>
    </div>
    